import React from "react";

import { Callout } from "Cobalt/Callout";
import { Title as Header } from "Cobalt/Header";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { CardSection } from "Common/Card";
import { launchSalesforceChat } from "Common/salesforceChatApi";

import Chrome from "./Chrome";

export interface ErrorPageProps {
  error: Error;
  errorOccurred: boolean;
  info?: {
    componentStack?: string;
  };
  href?: string;
  cta?: string;
}

const GenericErrorPage = ({ error, errorOccurred, info, href = "/", cta = "Back to Homepage" }: Partial<ErrorPageProps>) => (
  <Chrome p={0} title="Whoops!">
    <CardSection className="text-center">
      <Header className="text-center">WHOOPS!</Header>
      <BodyText>
        Looks like something went wrong.
        <br />
        Please go back and try again.
      </BodyText>
      <div className="flex flex-col gap-2 my-4">
        <Button href={href}>{cta}</Button>
        <Button color="link" onClick={launchSalesforceChat}>
          Chat Now
        </Button>
        <Button color="link" href="https://support.simplyinsured.com/s/contactsupport" target="_blank">
          Submit a Request
        </Button>
      </div>
    </CardSection>
    {errorOccurred && process.env.NODE_ENV === "development" && (
      <Callout
        className="mx-auto my-4"
        type="error"
        title={`${error.name} - ${error.message}`}
        body={
          <>
            {error.stack && (
              <div>
                <h2 className="text-body1 font-bold">Stack Trace</h2>
                <pre>
                  <code>{error.stack}</code>
                </pre>
              </div>
            )}
            {info?.componentStack && (
              <div>
                <h2 className="text-body1 font-bold">Component Trace</h2>
                <pre>
                  <code>{info?.componentStack}</code>
                </pre>
              </div>
            )}
          </>
        }
      />
    )}
  </Chrome>
);

export default GenericErrorPage;
